import React, { Component } from 'react';
import Styles from './App.module.scss';
import { Redirect, Route, Router, Switch } from 'react-router-dom';
import { observer } from 'mobx-react';
import { HISTORY } from './helper/HistoryHelper';
import Loading from './view/loading/Loading';
import Loaded from './view/loading/Loaded';
import ChatRouter from './view/chat/ChatRouter';
import CloseRouter from './view/close/CloseRouter';
import RatingRouter from './view/rating/RatingRouter';
import TestView from './view/TestView';
import Maintenance from './view/maintenance/Maintenance';
import ExpiredRouter from './view/expire/ExpiredRouter';
import EntryRouter from './view/EntryRouter';
import InitView2 from './view/InitView2';
import { PATH, ROUTE_PATTERN, LOADING_FROM_LANDING } from './const/path';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer } from 'react-notifications';

@observer
class App extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`d-flex flex-default ${Styles.Content}`}>
        <Router history={HISTORY}>
          <Switch>
            <Route path={PATH.INIT} component={EntryRouter} />
            <Route path={PATH.INIT2} component={InitView2} />
            <Route path={PATH.TEST} component={TestView} />
            <Route path={ROUTE_PATTERN.LOADING} component={Loading} />
            <Route path={ROUTE_PATTERN.CHAT} component={ChatRouter} />
            <Route path={PATH.CLOSE} component={CloseRouter} />
            <Route path={ROUTE_PATTERN.RATING} component={RatingRouter} />
            <Route path={PATH.MAINTENANCE} component={Maintenance} />
            <Route path={PATH.EXPIRED} component={ExpiredRouter} />
            <Route path={PATH.LOADED} component={Loaded} />
            {/* 랜딩 페이지 미구현 — 랜딩 단계를 건너뛰고 상담으로 진행 */}
            <Redirect
              from={PATH.LANDING}
              to={LOADING_FROM_LANDING}
              push={false}
            />
            <Redirect
              exact
              from="/"
              to={{
                pathname: PATH.LOADING,
                search: '',
              }}
              push={false}
            />
            <Route component={ExpiredRouter} />
          </Switch>
        </Router>
        <NotificationContainer />
      </div>
    );
  }
}

export default App;
